<template>
  <div v-if="value" class="overlay" @click.self="close">
    <div class="modal-box">
      <div class="modal-head">
        <h3 class="modal-title">🎁 Mahsulotni ustaga berish</h3>
        <button class="close-btn" @click="close">&times;</button>
      </div>

      <div class="modal-body">
        <!-- Mahsulot -->
        <div class="prod-info">
          <img v-if="product.image" :src="product.image" :alt="product.name" />
          <div v-else class="prod-img-placeholder">📦</div>
          <div>
            <div class="prod-name">{{ product.name }}</div>
            <div class="prod-price">🎁 <b>{{ product.ball_price }}</b> ball kerak</div>
          </div>
        </div>

        <!-- Usta tanlash -->
        <div class="field-group">
          <label class="flabel">Ustani tanlang</label>
          <input
            v-model="search"
            type="text"
            class="finput"
            placeholder="Usta nomi yoki telefoni..."
          />
        </div>

        <div class="usta-list">
          <div
            v-for="u in filteredUstalar"
            :key="u.id"
            class="usta-row"
            :class="{ selected: selectedId === u.id, insufficient: !canAfford(u) }"
            @click="selectedId = u.id"
          >
            <div class="usta-avatar">{{ u.name ? u.name[0] : 'U' }}</div>
            <div style="flex:1">
              <div class="usta-name">{{ u.name }}</div>
              <div class="usta-phone">{{ u.phone_number }}</div>
            </div>
            <div class="usta-ball" :class="canAfford(u) ? 'enough' : 'short'">
              <b>{{ getBallBalance(u.id) }}</b> ball
              <div v-if="!canAfford(u)" class="usta-warn">
                {{ Number(product.ball_price) - getBallBalance(u.id) }} ball yetishmaydi
              </div>
            </div>
          </div>

          <div v-if="filteredUstalar.length === 0" class="empty-mini">Usta topilmadi</div>
        </div>

        <div class="field-group">
          <label class="flabel">Izoh (ixtiyoriy)</label>
          <input v-model="comment" type="text" class="finput" placeholder="..." />
        </div>
      </div>

      <div class="modal-foot">
        <button class="btn-cancel-m" @click="close">Bekor</button>
        <button
          class="btn-save-m"
          @click="give"
          :disabled="loading || !selectedId || !canAffordSelected"
        >
          {{ loading ? 'Yuborilmoqda...' : 'Berish' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AksiyaGiveModal',
  props: {
    value:   { type: Boolean, default: false },
    product: { type: Object, required: true },
    ustalar: { type: Array,  default: () => [] },
  },
  data() {
    return {
      loading: false,
      search: '',
      selectedId: null,
      comment: '',
      ballReport: [],
    };
  },
  computed: {
    filteredUstalar() {
      const q = this.search.toLowerCase();
      if (!q) return this.ustalar;
      return this.ustalar.filter(u =>
        (u.name || '').toLowerCase().includes(q) ||
        (u.phone_number || '').includes(q)
      );
    },
    canAffordSelected() {
      if (!this.selectedId) return false;
      const u = this.ustalar.find(x => x.id === this.selectedId);
      return u ? this.canAfford(u) : false;
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.selectedId = null;
        this.search = '';
        this.comment = '';
        this.fetchBalances();
      }
    },
  },
  mounted() { this.fetchBalances(); },
  methods: {
    async fetchBalances() {
      try {
        const res = await axios.get('/api/v1/staff/balance-report');
        this.ballReport = res.data.items || [];
      } catch (e) { console.error(e); }
    },

    getBallBalance(id) {
      const r = this.ballReport.find(x => Number(x.staff_id) === Number(id));
      return r ? Number(r.ball_balance || 0) : 0;
    },
    canAfford(u) {
      return this.getBallBalance(u.id) >= Number(this.product.ball_price || 0);
    },
    close() { this.$emit('input', false); },

    async give() {
      if (!this.selectedId) return alert('Ustani tanlang!');
      if (!this.canAffordSelected) return alert('Ustaning balli yetishmaydi!');
      const u = this.ustalar.find(x => x.id === this.selectedId);
      if (!confirm(`"${this.product.name}" ${u.name} ga berilsinmi?\n${this.product.ball_price} ball ayriladi.`)) return;

      this.loading = true;
      try {
        const res = await axios.post(`/api/v1/ball-product/${this.product.id}/give`, {
          staff_id: this.selectedId,
          comment: this.comment || undefined,
        });
        const newBalance = res.data.data?.ball_balance ?? '?';
        alert(`✅ Berildi!\n${u.name} ning yangi balansi: ${newBalance} ball`);
        this.$emit('given');
        this.close();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 9500;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.modal-box {
  background: white; border-radius: 24px;
  width: 460px; max-width: 95vw;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  display: flex; flex-direction: column;
  max-height: 92vh; overflow: hidden;
}
.modal-head {
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}
.modal-body {
  padding: 18px 24px;
  overflow-y: auto;
  display: flex; flex-direction: column; gap: 14px;
}
.modal-foot {
  padding: 14px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px;
}

.prod-info {
  display: flex; gap: 12px; align-items: center;
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border: 1px solid #fbbf24;
  border-radius: 14px;
  padding: 12px 14px;
}
.prod-info img, .prod-img-placeholder {
  width: 56px; height: 56px;
  border-radius: 10px;
  background: white;
  object-fit: cover;
  display: flex; align-items: center; justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}
.prod-name { font-size: 14px; font-weight: 800; color: #92400e; }
.prod-price { font-size: 12px; color: #78350f; margin-top: 2px; }
.prod-price b { font-size: 16px; color: #d97706; }

.field-group { display: flex; flex-direction: column; gap: 6px; }
.flabel { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.3px; }
.finput {
  height: 42px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px; font-weight: 600; color: #1e293b;
  outline: none; transition: 0.2s;
  width: 100%; box-sizing: border-box;
}
.finput:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.1); }

.usta-list {
  display: flex; flex-direction: column; gap: 6px;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
}
.usta-row {
  display: flex; gap: 10px; align-items: center;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.12s;
  border: 2px solid transparent;
}
.usta-row:hover { background: #f8fafc; }
.usta-row.selected { background: #ede9fe; border-color: #5850ec; }
.usta-row.insufficient { opacity: 0.65; }
.usta-avatar {
  width: 38px; height: 38px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border-radius: 50%;
  font-size: 16px; font-weight: 900;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.usta-name { font-size: 14px; font-weight: 800; color: #1e293b; }
.usta-phone { font-size: 11px; color: #94a3b8; }
.usta-ball { text-align: right; font-size: 12px; }
.usta-ball b { font-size: 16px; font-weight: 900; }
.usta-ball.enough { color: #16a34a; }
.usta-ball.short  { color: #94a3b8; }
.usta-warn { font-size: 10px; color: #b91c1c; font-weight: 700; }
.empty-mini { text-align: center; padding: 20px; color: #94a3b8; font-size: 13px; }

.btn-cancel-m {
  flex: 1; height: 44px;
  background: #f1f5f9; color: #64748b;
  border: none; border-radius: 14px;
  font-weight: 700; cursor: pointer;
}
.btn-save-m {
  flex: 2; height: 44px;
  background: linear-gradient(135deg, #16a34a, #15803d);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
  transition: 0.2s;
}
.btn-save-m:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
